window.luxPopupInits = window.luxPopupInits || {};

/**
 * Highlight the account menu link matching the current page.
 *
 * @param {Element} panel - The cloned account menu popup element.
 * @returns {void}
 */
window.luxPopupInits.initAccountMenuPanel = function (panel) {
    const menuItems = panel.querySelectorAll(".lux-menu-wrapper a");

    menuItems.forEach((menuItem) => {
        const thisHref = menuItem.getAttribute("href")?.split("?")[0];

        if (thisHref === location.pathname) {
            menuItem.classList.add("active-menu");
        }
    });
};
